import { render, staticRenderFns } from "./applicant-data.vue?vue&type=template&id=1f62ce12"
import script from "./applicant-data.vue?vue&type=script&lang=js"
export * from "./applicant-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports